import React from 'react';
import { Brain } from 'lucide-react';

const SKILL_LEVELS = {
  0: { label: 'No Experience', color: 'bg-gray-200' },
  1: { label: 'Beginner', color: 'bg-red-200' },
  2: { label: 'Basic', color: 'bg-orange-200' },
  3: { label: 'Intermediate', color: 'bg-yellow-200' },
  4: { label: 'Advanced', color: 'bg-green-200' },
  5: { label: 'Expert', color: 'bg-blue-200' },
};

const SkillConfidenceSlider = ({ skill, value = 0, onChange, disabled = false }) => {
  const level = SKILL_LEVELS[value] || SKILL_LEVELS[0];

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Brain className="h-4 w-4 text-gray-400" />
          <span className="text-sm font-medium text-gray-700 capitalize">{skill}</span>
        </div>
        <span className="text-xs text-gray-500">{level.label}</span>
      </div>
      <div className="relative">
        <input
          type="range"
          min="0"
          max="5"
          step="1"
          value={value}
          onChange={(e) => onChange(parseInt(e.target.value))}
          disabled={disabled}
          className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer disabled:cursor-not-allowed"
          style={{
            background: `linear-gradient(to right, ${level.color} 0%, ${level.color} ${(value / 5) * 100}%, #e5e7eb ${(value / 5) * 100}%, #e5e7eb 100%)`
          }}
        />
        <div className="flex justify-between mt-1">
          {[0, 1, 2, 3, 4, 5].map((num) => (
            <span
              key={num}
              className={`text-xs ${value === num ? 'font-bold text-primary-600' : 'text-gray-400'}`}
            >
              {num}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkillConfidenceSlider;

